/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PendingApprovalRouteImport } from './routes/pending-approval'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AcceptInviteTokenRouteImport } from './routes/accept-invite.$token'
import { Route as AuthenticatedWorkspaceRouteImport } from './routes/_authenticated/workspace'
import { Route as AuthenticatedVslRouteImport } from './routes/_authenticated/vsl'
import { Route as AuthenticatedVoicesRouteImport } from './routes/_authenticated/voices'
import { Route as AuthenticatedUpdatesRouteImport } from './routes/_authenticated/updates'
import { Route as AuthenticatedTranslateRouteImport } from './routes/_authenticated/translate'
import { Route as AuthenticatedTranscriptionRouteImport } from './routes/_authenticated/transcription'
import { Route as AuthenticatedTemplatesRouteImport } from './routes/_authenticated/templates'
import { Route as AuthenticatedSupportRouteImport } from './routes/_authenticated/support'
import { Route as AuthenticatedStatsRouteImport } from './routes/_authenticated/stats'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedQuickTasksRouteImport } from './routes/_authenticated/quick-tasks'
import { Route as AuthenticatedProjectsRouteImport } from './routes/_authenticated/projects'
import { Route as AuthenticatedOverlayRouteImport } from './routes/_authenticated/overlay'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedFaqRouteImport } from './routes/_authenticated/faq'
import { Route as AuthenticatedDataRouteImport } from './routes/_authenticated/data'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCompressRouteImport } from './routes/_authenticated/compress'
import { Route as AuthenticatedAudioMaskRouteImport } from './routes/_authenticated/audio-mask'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedVslIndexRouteImport } from './routes/_authenticated/vsl.index'
import { Route as AuthenticatedVslScriptsRouteImport } from './routes/_authenticated/vsl.scripts'
import { Route as AuthenticatedVslRunsRouteImport } from './routes/_authenticated/vsl.runs'
import { Route as AuthenticatedVslNewRouteImport } from './routes/_authenticated/vsl.new'
import { Route as AuthenticatedVslBasesRouteImport } from './routes/_authenticated/vsl.bases'
import { Route as AuthenticatedProjectsIdRouteImport } from './routes/_authenticated/projects_.$id'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PendingApprovalRoute = PendingApprovalRouteImport.update({
  id: '/pending-approval',
  path: '/pending-approval',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteTokenRoute = AcceptInviteTokenRouteImport.update({
  id: '/accept-invite/$token',
  path: '/accept-invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWorkspaceRoute = AuthenticatedWorkspaceRouteImport.update({
  id: '/workspace',
  path: '/workspace',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedVslRoute = AuthenticatedVslRouteImport.update({
  id: '/vsl',
  path: '/vsl',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedVoicesRoute = AuthenticatedVoicesRouteImport.update({
  id: '/voices',
  path: '/voices',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUpdatesRoute = AuthenticatedUpdatesRouteImport.update({
  id: '/updates',
  path: '/updates',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTranslateRoute = AuthenticatedTranslateRouteImport.update({
  id: '/translate',
  path: '/translate',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTranscriptionRoute =
  AuthenticatedTranscriptionRouteImport.update({
    id: '/transcription',
    path: '/transcription',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTemplatesRoute = AuthenticatedTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSupportRoute = AuthenticatedSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedStatsRoute = AuthenticatedStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedQuickTasksRoute = AuthenticatedQuickTasksRouteImport.update({
  id: '/quick-tasks',
  path: '/quick-tasks',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProjectsRoute = AuthenticatedProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOverlayRoute = AuthenticatedOverlayRouteImport.update({
  id: '/overlay',
  path: '/overlay',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFaqRoute = AuthenticatedFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDataRoute = AuthenticatedDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCompressRoute = AuthenticatedCompressRouteImport.update({
  id: '/compress',
  path: '/compress',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAudioMaskRoute = AuthenticatedAudioMaskRouteImport.update({
  id: '/audio-mask',
  path: '/audio-mask',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedVslIndexRoute = AuthenticatedVslIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedVslRoute,
} as any)
const AuthenticatedVslScriptsRoute = AuthenticatedVslScriptsRouteImport.update({
  id: '/scripts',
  path: '/scripts',
  getParentRoute: () => AuthenticatedVslRoute,
} as any)
const AuthenticatedVslRunsRoute = AuthenticatedVslRunsRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => AuthenticatedVslRoute,
} as any)
const AuthenticatedVslNewRoute = AuthenticatedVslNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedVslRoute,
} as any)
const AuthenticatedVslBasesRoute = AuthenticatedVslBasesRouteImport.update({
  id: '/bases',
  path: '/bases',
  getParentRoute: () => AuthenticatedVslRoute,
} as any)
const AuthenticatedProjectsIdRoute = AuthenticatedProjectsIdRouteImport.update({
  id: '/projects_/$id',
  path: '/projects/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/pending-approval': typeof PendingApprovalRoute
  '/register': typeof RegisterRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/audio-mask': typeof AuthenticatedAudioMaskRoute
  '/compress': typeof AuthenticatedCompressRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/data': typeof AuthenticatedDataRoute
  '/faq': typeof AuthenticatedFaqRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/overlay': typeof AuthenticatedOverlayRoute
  '/projects': typeof AuthenticatedProjectsRoute
  '/quick-tasks': typeof AuthenticatedQuickTasksRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/stats': typeof AuthenticatedStatsRoute
  '/support': typeof AuthenticatedSupportRoute
  '/templates': typeof AuthenticatedTemplatesRoute
  '/transcription': typeof AuthenticatedTranscriptionRoute
  '/translate': typeof AuthenticatedTranslateRoute
  '/updates': typeof AuthenticatedUpdatesRoute
  '/voices': typeof AuthenticatedVoicesRoute
  '/vsl': typeof AuthenticatedVslRouteWithChildren
  '/workspace': typeof AuthenticatedWorkspaceRoute
  '/accept-invite/$token': typeof AcceptInviteTokenRoute
  '/projects/$id': typeof AuthenticatedProjectsIdRoute
  '/vsl/bases': typeof AuthenticatedVslBasesRoute
  '/vsl/new': typeof AuthenticatedVslNewRoute
  '/vsl/runs': typeof AuthenticatedVslRunsRoute
  '/vsl/scripts': typeof AuthenticatedVslScriptsRoute
  '/vsl/': typeof AuthenticatedVslIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/pending-approval': typeof PendingApprovalRoute
  '/register': typeof RegisterRoute
  '/verify-email': typeof VerifyEmailRoute
  '/admin': typeof AuthenticatedAdminRoute
  '/audio-mask': typeof AuthenticatedAudioMaskRoute
  '/compress': typeof AuthenticatedCompressRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/data': typeof AuthenticatedDataRoute
  '/faq': typeof AuthenticatedFaqRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/overlay': typeof AuthenticatedOverlayRoute
  '/projects': typeof AuthenticatedProjectsRoute
  '/quick-tasks': typeof AuthenticatedQuickTasksRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/stats': typeof AuthenticatedStatsRoute
  '/support': typeof AuthenticatedSupportRoute
  '/templates': typeof AuthenticatedTemplatesRoute
  '/transcription': typeof AuthenticatedTranscriptionRoute
  '/translate': typeof AuthenticatedTranslateRoute
  '/updates': typeof AuthenticatedUpdatesRoute
  '/voices': typeof AuthenticatedVoicesRoute
  '/workspace': typeof AuthenticatedWorkspaceRoute
  '/accept-invite/$token': typeof AcceptInviteTokenRoute
  '/projects/$id': typeof AuthenticatedProjectsIdRoute
  '/vsl/bases': typeof AuthenticatedVslBasesRoute
  '/vsl/new': typeof AuthenticatedVslNewRoute
  '/vsl/runs': typeof AuthenticatedVslRunsRoute
  '/vsl/scripts': typeof AuthenticatedVslScriptsRoute
  '/vsl': typeof AuthenticatedVslIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/pending-approval': typeof PendingApprovalRoute
  '/register': typeof RegisterRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRoute
  '/_authenticated/audio-mask': typeof AuthenticatedAudioMaskRoute
  '/_authenticated/compress': typeof AuthenticatedCompressRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/data': typeof AuthenticatedDataRoute
  '/_authenticated/faq': typeof AuthenticatedFaqRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/overlay': typeof AuthenticatedOverlayRoute
  '/_authenticated/projects': typeof AuthenticatedProjectsRoute
  '/_authenticated/quick-tasks': typeof AuthenticatedQuickTasksRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/stats': typeof AuthenticatedStatsRoute
  '/_authenticated/support': typeof AuthenticatedSupportRoute
  '/_authenticated/templates': typeof AuthenticatedTemplatesRoute
  '/_authenticated/transcription': typeof AuthenticatedTranscriptionRoute
  '/_authenticated/translate': typeof AuthenticatedTranslateRoute
  '/_authenticated/updates': typeof AuthenticatedUpdatesRoute
  '/_authenticated/voices': typeof AuthenticatedVoicesRoute
  '/_authenticated/vsl': typeof AuthenticatedVslRouteWithChildren
  '/_authenticated/workspace': typeof AuthenticatedWorkspaceRoute
  '/accept-invite/$token': typeof AcceptInviteTokenRoute
  '/_authenticated/projects_/$id': typeof AuthenticatedProjectsIdRoute
  '/_authenticated/vsl/bases': typeof AuthenticatedVslBasesRoute
  '/_authenticated/vsl/new': typeof AuthenticatedVslNewRoute
  '/_authenticated/vsl/runs': typeof AuthenticatedVslRunsRoute
  '/_authenticated/vsl/scripts': typeof AuthenticatedVslScriptsRoute
  '/_authenticated/vsl/': typeof AuthenticatedVslIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/pending-approval'
    | '/register'
    | '/verify-email'
    | '/admin'
    | '/audio-mask'
    | '/compress'
    | '/dashboard'
    | '/data'
    | '/faq'
    | '/notifications'
    | '/overlay'
    | '/projects'
    | '/quick-tasks'
    | '/settings'
    | '/stats'
    | '/support'
    | '/templates'
    | '/transcription'
    | '/translate'
    | '/updates'
    | '/voices'
    | '/vsl'
    | '/workspace'
    | '/accept-invite/$token'
    | '/projects/$id'
    | '/vsl/bases'
    | '/vsl/new'
    | '/vsl/runs'
    | '/vsl/scripts'
    | '/vsl/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/pending-approval'
    | '/register'
    | '/verify-email'
    | '/admin'
    | '/audio-mask'
    | '/compress'
    | '/dashboard'
    | '/data'
    | '/faq'
    | '/notifications'
    | '/overlay'
    | '/projects'
    | '/quick-tasks'
    | '/settings'
    | '/stats'
    | '/support'
    | '/templates'
    | '/transcription'
    | '/translate'
    | '/updates'
    | '/voices'
    | '/workspace'
    | '/accept-invite/$token'
    | '/projects/$id'
    | '/vsl/bases'
    | '/vsl/new'
    | '/vsl/runs'
    | '/vsl/scripts'
    | '/vsl'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/pending-approval'
    | '/register'
    | '/verify-email'
    | '/_authenticated/admin'
    | '/_authenticated/audio-mask'
    | '/_authenticated/compress'
    | '/_authenticated/dashboard'
    | '/_authenticated/data'
    | '/_authenticated/faq'
    | '/_authenticated/notifications'
    | '/_authenticated/overlay'
    | '/_authenticated/projects'
    | '/_authenticated/quick-tasks'
    | '/_authenticated/settings'
    | '/_authenticated/stats'
    | '/_authenticated/support'
    | '/_authenticated/templates'
    | '/_authenticated/transcription'
    | '/_authenticated/translate'
    | '/_authenticated/updates'
    | '/_authenticated/voices'
    | '/_authenticated/vsl'
    | '/_authenticated/workspace'
    | '/accept-invite/$token'
    | '/_authenticated/projects_/$id'
    | '/_authenticated/vsl/bases'
    | '/_authenticated/vsl/new'
    | '/_authenticated/vsl/runs'
    | '/_authenticated/vsl/scripts'
    | '/_authenticated/vsl/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PendingApprovalRoute: typeof PendingApprovalRoute
  RegisterRoute: typeof RegisterRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  AcceptInviteTokenRoute: typeof AcceptInviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pending-approval': {
      id: '/pending-approval'
      path: '/pending-approval'
      fullPath: '/pending-approval'
      preLoaderRoute: typeof PendingApprovalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite/$token': {
      id: '/accept-invite/$token'
      path: '/accept-invite/$token'
      fullPath: '/accept-invite/$token'
      preLoaderRoute: typeof AcceptInviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/workspace': {
      id: '/_authenticated/workspace'
      path: '/workspace'
      fullPath: '/workspace'
      preLoaderRoute: typeof AuthenticatedWorkspaceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vsl': {
      id: '/_authenticated/vsl'
      path: '/vsl'
      fullPath: '/vsl'
      preLoaderRoute: typeof AuthenticatedVslRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/voices': {
      id: '/_authenticated/voices'
      path: '/voices'
      fullPath: '/voices'
      preLoaderRoute: typeof AuthenticatedVoicesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/updates': {
      id: '/_authenticated/updates'
      path: '/updates'
      fullPath: '/updates'
      preLoaderRoute: typeof AuthenticatedUpdatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/translate': {
      id: '/_authenticated/translate'
      path: '/translate'
      fullPath: '/translate'
      preLoaderRoute: typeof AuthenticatedTranslateRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/transcription': {
      id: '/_authenticated/transcription'
      path: '/transcription'
      fullPath: '/transcription'
      preLoaderRoute: typeof AuthenticatedTranscriptionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/templates': {
      id: '/_authenticated/templates'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof AuthenticatedTemplatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/support': {
      id: '/_authenticated/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedSupportRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/stats': {
      id: '/_authenticated/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof AuthenticatedStatsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/quick-tasks': {
      id: '/_authenticated/quick-tasks'
      path: '/quick-tasks'
      fullPath: '/quick-tasks'
      preLoaderRoute: typeof AuthenticatedQuickTasksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/projects': {
      id: '/_authenticated/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AuthenticatedProjectsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/overlay': {
      id: '/_authenticated/overlay'
      path: '/overlay'
      fullPath: '/overlay'
      preLoaderRoute: typeof AuthenticatedOverlayRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/faq': {
      id: '/_authenticated/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof AuthenticatedFaqRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/data': {
      id: '/_authenticated/data'
      path: '/data'
      fullPath: '/data'
      preLoaderRoute: typeof AuthenticatedDataRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/compress': {
      id: '/_authenticated/compress'
      path: '/compress'
      fullPath: '/compress'
      preLoaderRoute: typeof AuthenticatedCompressRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audio-mask': {
      id: '/_authenticated/audio-mask'
      path: '/audio-mask'
      fullPath: '/audio-mask'
      preLoaderRoute: typeof AuthenticatedAudioMaskRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/vsl/': {
      id: '/_authenticated/vsl/'
      path: '/'
      fullPath: '/vsl/'
      preLoaderRoute: typeof AuthenticatedVslIndexRouteImport
      parentRoute: typeof AuthenticatedVslRoute
    }
    '/_authenticated/vsl/scripts': {
      id: '/_authenticated/vsl/scripts'
      path: '/scripts'
      fullPath: '/vsl/scripts'
      preLoaderRoute: typeof AuthenticatedVslScriptsRouteImport
      parentRoute: typeof AuthenticatedVslRoute
    }
    '/_authenticated/vsl/runs': {
      id: '/_authenticated/vsl/runs'
      path: '/runs'
      fullPath: '/vsl/runs'
      preLoaderRoute: typeof AuthenticatedVslRunsRouteImport
      parentRoute: typeof AuthenticatedVslRoute
    }
    '/_authenticated/vsl/new': {
      id: '/_authenticated/vsl/new'
      path: '/new'
      fullPath: '/vsl/new'
      preLoaderRoute: typeof AuthenticatedVslNewRouteImport
      parentRoute: typeof AuthenticatedVslRoute
    }
    '/_authenticated/vsl/bases': {
      id: '/_authenticated/vsl/bases'
      path: '/bases'
      fullPath: '/vsl/bases'
      preLoaderRoute: typeof AuthenticatedVslBasesRouteImport
      parentRoute: typeof AuthenticatedVslRoute
    }
    '/_authenticated/projects_/$id': {
      id: '/_authenticated/projects_/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof AuthenticatedProjectsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedVslRouteChildren {
  AuthenticatedVslBasesRoute: typeof AuthenticatedVslBasesRoute
  AuthenticatedVslNewRoute: typeof AuthenticatedVslNewRoute
  AuthenticatedVslRunsRoute: typeof AuthenticatedVslRunsRoute
  AuthenticatedVslScriptsRoute: typeof AuthenticatedVslScriptsRoute
  AuthenticatedVslIndexRoute: typeof AuthenticatedVslIndexRoute
}

const AuthenticatedVslRouteChildren: AuthenticatedVslRouteChildren = {
  AuthenticatedVslBasesRoute: AuthenticatedVslBasesRoute,
  AuthenticatedVslNewRoute: AuthenticatedVslNewRoute,
  AuthenticatedVslRunsRoute: AuthenticatedVslRunsRoute,
  AuthenticatedVslScriptsRoute: AuthenticatedVslScriptsRoute,
  AuthenticatedVslIndexRoute: AuthenticatedVslIndexRoute,
}

const AuthenticatedVslRouteWithChildren =
  AuthenticatedVslRoute._addFileChildren(AuthenticatedVslRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRoute
  AuthenticatedAudioMaskRoute: typeof AuthenticatedAudioMaskRoute
  AuthenticatedCompressRoute: typeof AuthenticatedCompressRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedDataRoute: typeof AuthenticatedDataRoute
  AuthenticatedFaqRoute: typeof AuthenticatedFaqRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedOverlayRoute: typeof AuthenticatedOverlayRoute
  AuthenticatedProjectsRoute: typeof AuthenticatedProjectsRoute
  AuthenticatedQuickTasksRoute: typeof AuthenticatedQuickTasksRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedStatsRoute: typeof AuthenticatedStatsRoute
  AuthenticatedSupportRoute: typeof AuthenticatedSupportRoute
  AuthenticatedTemplatesRoute: typeof AuthenticatedTemplatesRoute
  AuthenticatedTranscriptionRoute: typeof AuthenticatedTranscriptionRoute
  AuthenticatedTranslateRoute: typeof AuthenticatedTranslateRoute
  AuthenticatedUpdatesRoute: typeof AuthenticatedUpdatesRoute
  AuthenticatedVoicesRoute: typeof AuthenticatedVoicesRoute
  AuthenticatedVslRoute: typeof AuthenticatedVslRouteWithChildren
  AuthenticatedWorkspaceRoute: typeof AuthenticatedWorkspaceRoute
  AuthenticatedProjectsIdRoute: typeof AuthenticatedProjectsIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,
  AuthenticatedAudioMaskRoute: AuthenticatedAudioMaskRoute,
  AuthenticatedCompressRoute: AuthenticatedCompressRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedDataRoute: AuthenticatedDataRoute,
  AuthenticatedFaqRoute: AuthenticatedFaqRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedOverlayRoute: AuthenticatedOverlayRoute,
  AuthenticatedProjectsRoute: AuthenticatedProjectsRoute,
  AuthenticatedQuickTasksRoute: AuthenticatedQuickTasksRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedStatsRoute: AuthenticatedStatsRoute,
  AuthenticatedSupportRoute: AuthenticatedSupportRoute,
  AuthenticatedTemplatesRoute: AuthenticatedTemplatesRoute,
  AuthenticatedTranscriptionRoute: AuthenticatedTranscriptionRoute,
  AuthenticatedTranslateRoute: AuthenticatedTranslateRoute,
  AuthenticatedUpdatesRoute: AuthenticatedUpdatesRoute,
  AuthenticatedVoicesRoute: AuthenticatedVoicesRoute,
  AuthenticatedVslRoute: AuthenticatedVslRouteWithChildren,
  AuthenticatedWorkspaceRoute: AuthenticatedWorkspaceRoute,
  AuthenticatedProjectsIdRoute: AuthenticatedProjectsIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PendingApprovalRoute: PendingApprovalRoute,
  RegisterRoute: RegisterRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  AcceptInviteTokenRoute: AcceptInviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
